export const set = (state, action) => {
  return { ...state, account: action.payload };
};
